import { useTranslation } from 'react-i18next';
import { components } from 'react-select';
import { useAppDispatch } from '../../../app/hooks';
import { getValueFromResource } from '../../../common/timeLiveFunction';

export const CustomNoOptionsMessage = (props: any) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const inputValue = props.selectProps?.inputValue || '';

    if (inputValue.trim()) {
        return (
            <components.NoOptionsMessage {...props}>
                {getValueFromResource('Press', dispatch, t)} <strong>{getValueFromResource('Ctrl + Enter', dispatch, t)}</strong>{getValueFromResource(' to add this zone type', dispatch, t)}
            </components.NoOptionsMessage>
        );
    }

    return (
        <components.NoOptionsMessage {...props}>
            {getValueFromResource('No options available', dispatch, t)}
        </components.NoOptionsMessage>
    );
};